import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskItineraryPrintItemCtrl implements IController {

  index: any;
  task: TaskModel;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskItineraryPrintItem', {
    bindings: {
      index: '<',
      task: '<'
    },
    template: require('./task-itinerary-print-item.html').default,
    controller: taskItineraryPrintItemCtrl
  });
